import {
  CodeReviewerRepositorySetting,
  CodeReviewerSettingContainerType,
} from 'src/components/rovo-dev-agents/src/hooks/types';

import { useCodeReviewerSetting } from './use-code-reviewer-setting';

export const useCodeReviewerRepositorySetting = (
  forceInvalidateCache = false
): CodeReviewerRepositorySetting => {
  const {
    error,
    isLoading,
    workspaceSettings,
    isRepositoryDisabledForAutoreview,
    repositorySettings,
    updateRepositorySetting,
  } = useCodeReviewerSetting({
    containerType: CodeReviewerSettingContainerType.Repository,
    forceInvalidateCache,
  });

  return {
    error,
    isLoading,
    workspaceSettings,
    isRepositoryDisabledForAutoreview,
    repositorySettings,
    updateRepositorySetting,
  };
};
